var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-item"},[_vm._t("icon"),_c('div',{staticClass:"contact-item__info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }